import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import BarCharts from 'src/components/common/charts/BarCharts'
import { COLORS } from 'src/utils/Themes/colors'
import { GRAPH_CONSTANTS } from 'src/utils/constants/RiskReports'

const CHART_COLORS = [
  COLORS?.BAR_CHART_COLOR1,
  COLORS?.BAR_CHART_COLOR2,
  COLORS?.BAR_CHART_COLOR3,
  COLORS?.BAR_CHART_COLOR3,
  COLORS?.BAR_CHART_COLOR2,
  COLORS?.BAR_CHART_COLOR1,
]

const AgeGraph = ({ data, chartHeight, series, categories }) => {
  const classes = useStyles()

  return (
    <div>
      <Card className={classes.cardContainer}>
        <CardContent>
          <h2 className={classes.title}>
            <span id='heading'>Age Graph</span>

            {/* <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedYear}
              onChange={handleChange}
              label=""
            >
              {YEARS.map((y) => (
                <MenuItem
                  key={`year-${y}`}
                  classes={{ root: classes.menuItem }}
                  value={y}
                >
                  {y}
                </MenuItem>
              ))}
            </Select> */}
            {/* might be reserved for future use */}
          </h2>
          {data && data?.length === 0 ? null : (
            <BarCharts
              categories={categories}
              series={series}
              height={chartHeight}
              colors={CHART_COLORS}
              type={GRAPH_CONSTANTS?.AGE_GRAPH}
            />
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default AgeGraph

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
    // boxShadow: "4px 7px 15px rgba(0, 0, 0, 0.1)",
  },
  cardContainer: {
    borderRadius: '10px',
    padding: '6px',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',

    lineHeight: '22px',
    marginTop: '0px',
    padding: '0px 32px',
    color: '#333333',
    '& .MuiSelect-select': {
      padding: '0 14px 0 10px',
      fontWeight: 600,
      borderBottom: '1px solid #bbbbbb',
      borderRadius: 0,
    },
    '& fieldset': {
      border: '0px',
    },
  },
  menuItem: {
    paddingLeft: '16px',
    '&.MuiListItem-gutters': {
      paddingLeft: '16px !important',
    },
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: '#02A9F4',
    textDecoration: 'underline',
    marginTop: '-15px',
  },
})
